import { UnreadType, Notifications } from './utils';

export enum NotificationsPoints {
  GET_NOTIFICATIONS = 'profile/notifications/get',
  GET_UNREAD_COUNT = 'profile/notifications/unread-count',
  POST_READED_NOTIFICATIONS = 'profile/notification/read',
}

export type UnreadCount = { data: UnreadType };
export type NotificationsData = { data: Array<Notifications> };



// WEBPACK FOOTER //
// ./src/services/notifications/types.ts